
import { CloseCircleFilled, CloseOutlined } from '@ant-design/icons-vue';
import { BooleanHelper, OioCommonProps, OioMetadataProps, translateValueByKey } from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';
import { computed, defineComponent, ref, watch } from 'vue';

export default defineComponent({
  props: {
    ...OioCommonProps,
    ...OioMetadataProps,
    value: {
      type: Array
    },
    inputRegular: {
      type: [String, RegExp]
    },
    tagChange: {
      type: Function
    },
    blur: {
      type: Function
    },
    placeholder: {
      type: String
    },
    defaultValue: {
      type: Array
    },
    unitValueLength: {
      type: Number
    },
    allowClear: {
      type: Boolean
    },
    allowRepeat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CloseCircleFilled,
    CloseOutlined
  },
  setup(props) {
    const current = ref('');
    const tags = ref<any>(props.defaultValue || []);
    const readonly = computed(() => BooleanHelper.toBoolean(props.readonly));
    const disabled = computed(() => BooleanHelper.toBoolean(props.disabled));

    const clearStatus = computed(() => {
      return !readonly.value && !disabled.value && tags.value.length > 0 && props.allowClear;
    });

    const currentChange = (val) => {
      current.value = val.target.value;
    };

    const addTag = (e) => {
      let val = e.target.value;
      if (!val) {
        props.blur?.();
        return;
      }
      if (props.inputRegular) {
        val = val.replace(props.inputRegular, '');
      }
      // if (tags.value.includes(val)) {
      //   if (!props.allowRepeat) {
      //     OioNotification.error(translateValueByKey('错误'), translateValueByKey('标签已经存在，不可重复'));
      //     return;
      //   }
      // }
      if (!val) {
        props.blur?.();
        current.value = '';
        return;
      }

      // 支持从excel复制一列数据来输入
      if (/\s/g.test(val)) {
        val = val.replace(/\s/g, ',');
        val = val.split(',').filter((item) => item);
        val = Array.from(new Set(val));
      }

      tags.value = tags.value.concat(val);
      current.value = '';
      props.tagChange?.(tags.value);
    };

    const delTag = (index) => {
      tags.value.splice(index, 1);
      props.tagChange?.(tags.value);
    };

    const clearTag = () => {
      tags.value = [];
      props.tagChange?.(tags.value);
      current.value = '';
    };

    watch(
      () => props.value,
      (newVal) => {
        if (newVal === null) {
          tags.value = [];
        } else {
          tags.value = newVal || [];
        }
      },
      { immediate: true }
    );

    return {
      current,
      tags,
      readonly,
      disabled,
      clearStatus,
      currentChange,
      addTag,
      delTag,
      clearTag
    };
  }
});
